import { styled, Box } from "@mui/material";
import { WIDGET_GEOMETRY } from "../../iframe/widgetGeometry";

// Shared with the iframe host bridge — see widgetGeometry.ts.
const StyledMinimizedChatPopUp = styled(Box)(() => ({
  position: "fixed",
  bottom: `${WIDGET_GEOMETRY.popup.bottomOffset}px`,
  right: `${WIDGET_GEOMETRY.margin}px`,
  zIndex: 2000,
  display: "flex",
  flexDirection: "column",
  gap: "14px",
  maxWidth: `${WIDGET_GEOMETRY.popup.maxWidth}px`,
  backgroundColor: "#fff",
  borderRadius: "8px",
  boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",

  "@keyframes fadeIn": {
    from: {
      right: "-300px",
    },
    to: {
      right: "0px",
    },
  },
  animation: "fadeIn 0.3s",
}));

export default StyledMinimizedChatPopUp;
